import React from 'react'
import { Box, IconButton, Menu, MenuItem } from '@mui/material'
import { Dotsmenu } from '@e3dc-react/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import useModals from 'src/Hooks/useModals'
import { ChargingCardModel } from '../api/models/charging-card-model'
import { useHagerBridgePermissions } from '../../shared/hooks/use-hager-bridge-permissions'
import { useNavigate } from 'react-router-dom'
import { updateChargingSessionsFilters } from 'src/State/E-Mobility/EMobilityStateAction'
import { useDispatch } from 'react-redux'

interface ChargingCardsTableMenuIconProps {
  chargingCard: ChargingCardModel
  installationId: number
}

export const chargingCardMenuButtonId = 'e-mobility-charging-cards-menu-button'

/** Component shows charging cards table action button */
export const ChargingCardsTableMenuIcon: React.FC<ChargingCardsTableMenuIconProps> = ({ chargingCard, installationId }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const isOpen = Boolean(anchorEl)
  const { t } = useCustomTranslation()
  const { permissions } = useHagerBridgePermissions()
  const { chargingCardPermissions } = permissions
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { openEditChargingCardDialog, openDeleteChargingCardDialog } = useModals()

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (event: React.MouseEvent<HTMLLIElement, MouseEvent>): void => {
    event.stopPropagation()
    setAnchorEl(null)
  }

  return (
    <Box>
      <IconButton onClick={handleClick} id={chargingCardMenuButtonId}>
        <Dotsmenu />
      </IconButton>
      <Menu anchorEl={anchorEl} open={isOpen} onClose={handleClose}>
        {(chargingCardPermissions.editChargingCard || chargingCardPermissions.editChargingCardStatus) && (
          <MenuItem
            onClick={event => {
              event.stopPropagation()
              handleClose(event)
              openEditChargingCardDialog({ chargingCard })
            }}
          >
            {chargingCardPermissions.editChargingCard
              ? t('emobility.chargingCards.editChargingCard')
              : t('emobility.chargingCards.edit-charging-card-status')}
          </MenuItem>
        )}
        {chargingCardPermissions.deleteChargingCard && (
          <MenuItem
            onClick={event => {
              event.stopPropagation()
              handleClose(event)
              openDeleteChargingCardDialog({
                installationId,
                ocpiTokenId: chargingCard.ocpiTokenId,
                cardName: chargingCard.cardName,
                rfid: chargingCard.tokenId,
              })
            }}
          >
            {t('emobility.chargingCards.deleteChargingCard')}
          </MenuItem>
        )}
        <MenuItem
          onClick={event => {
            event.stopPropagation()
            dispatch(updateChargingSessionsFilters({ ocpiTokenIds: [chargingCard.ocpiTokenId], page: 0 }))
            navigate(`/e-mobility/${chargingCard.installationId}/charging-sessions`)
          }}
        >
          {t('emobility.chargingCards.viewChargingSessions')}
        </MenuItem>
      </Menu>
    </Box>
  )
}
